import { useMutation, useQueryClient } from "@tanstack/react-query";

import { putPartnerModulesModuleModuleID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { MODULE_PARTNERS_QUERY_KEY } from "../Queries/useModulePartnersQuery";

interface SetModulePartnersParams {
  moduleID: string;
  partnerIDs: string[];
}

export function useSetModulePartnersMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ moduleID, partnerIDs }: SetModulePartnersParams) =>
      putPartnerModulesModuleModuleID({ partnerIDs }, moduleID),
    {
      translationPrefix: getResourcePath(Resources.ApiErrors.SetModulePartners),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { moduleID }) => {
      queryClient.invalidateQueries({
        queryKey: MODULE_PARTNERS_QUERY_KEY(moduleID),
      });
    },
  });
}
